import { isMobileDevice } from "./TouchControls.js";

export function initWelcomePopup(options = {}) {
  const onClose = options.onClose || (() => {});
  const onOpen = options.onOpen || (() => {});

  // if (localStorage.getItem(STORAGE_KEY)) return;

  const overlay = document.getElementById("welcomeOverlay");
  const closeBtn = document.getElementById("welcomeCloseBtn");
  const reopenBtn = document.getElementById("reopenWelcomeBtn");
  const tabBtns = document.querySelectorAll(".wp-tab-btn");
  const tabPanels = document.querySelectorAll(".wp-tab-panel");

  // Mobil / Masaüstü içerik geçişi
  // Mobil / Masaüstü içerik geçişi
  const isMobile = isMobileDevice();
  
  // Hareket Tabı İçerikleri
  const desktopMovementInfo = document.getElementById("desktop-movement-info");
  const mobileMovementInfo = document.getElementById("mobile-movement-info");
  
  // Kamera Tabı İçerikleri
  const desktopCameraInfo = document.getElementById("desktop-camera-info");
  const mobileCameraInfo = document.getElementById("mobile-camera-info");

  if (isMobile) {
    if (desktopMovementInfo) desktopMovementInfo.style.display = "none";
    if (mobileMovementInfo) mobileMovementInfo.style.display = "block";
    
    if (desktopCameraInfo) desktopCameraInfo.style.display = "none";
    if (mobileCameraInfo) mobileCameraInfo.style.display = "block";
  } else {
    if (desktopMovementInfo) desktopMovementInfo.style.display = "block";
    if (mobileMovementInfo) mobileMovementInfo.style.display = "none";
    
    if (desktopCameraInfo) desktopCameraInfo.style.display = "block";
    if (mobileCameraInfo) mobileCameraInfo.style.display = "none";
  }

  if (!overlay) return;

  // show overlay
  overlay.classList.remove("wp-hidden");

  // Tab switching
  tabBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = btn.dataset.tab;

      tabBtns.forEach((b) => b.classList.remove("active"));
      tabPanels.forEach((p) => p.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById(`wp-tab-${target}`).classList.add("active");
    });
  });

  //reopen popup 
  if (reopenBtn) {
    reopenBtn.addEventListener("click", () => {
      overlay.classList.remove("wp-hidden");
      onOpen();
    });
  }

  //closing
  function closePopup() {
    overlay.classList.add("wp-closing");
    setTimeout(() => {
      overlay.classList.add("wp-hidden");
      overlay.classList.remove("wp-closing");
      onClose();  
    }, 400);
    
  }

  closeBtn.addEventListener("click", closePopup);

  //Close it when you click outside the overlay
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closePopup();
  });

  // close with ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !overlay.classList.contains("wp-hidden")) {
      closePopup();
    }
  });
}